import { IdentityProfileCard, VoiceSpeechCard } from "@/components/agent/details";
import { CoreDrawer } from "@/components/common/CoreDrawer";
import { useRole } from "@/hooks/auth/useRole";
import { Agent } from "@/types/agent/agent";

interface IdentityDrawerProps {
  genie: Agent;
  isOpen: boolean;
  onClose: () => void;
}

export default function IdentityDrawer({ genie, isOpen, onClose }: IdentityDrawerProps) {
  const brand = genie.branding?.primaryColor ?? "#4E9CFF";
  const { isInternalAdmin } = useRole();

  const title = genie.name ? `${genie.name}'s Identity` : "Genie Identity";

  return (
    <CoreDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description="Manage your genie's profile, purpose, and voice characteristics."
    >
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 xl:items-stretch">
        <IdentityProfileCard agent={genie} brand={brand} />
        <VoiceSpeechCard agent={genie} brand={brand} isAdmin={isInternalAdmin()} />
      </div>
    </CoreDrawer>
  );
}
